import { useEffect, useState } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_bf707ab1-d809-4aca-a466-4390571c997b/artifacts/6hmyyhtk_23Recurso%203.png";

export default function LoadingScreen({ onDone, durationMs = 5000 }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.min(100, (elapsed / durationMs) * 100);
      setProgress(pct);
      if (elapsed >= durationMs) {
        clearInterval(interval);
        onDone?.();
      }
    }, 40);
    return () => clearInterval(interval);
  }, [durationMs, onDone]);

  return (
    <div
      data-testid="loading-screen"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-[#05080f]"
    >
      {/* radial blue glow */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[60vmin] w-[60vmin] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1e88ff] opacity-[0.10] blur-[120px]" />
        <div className="absolute left-1/2 top-1/2 h-[30vmin] w-[30vmin] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#3aa0ff] opacity-[0.18] blur-[80px]" />
      </div>

      {/* logo */}
      <div className="relative flex items-center justify-center">
        <div className="absolute inset-0 -m-10 animate-pulse rounded-full bg-[#1e88ff]/10 blur-3xl" />
        <img
          src={LOGO_URL}
          alt="Logo"
          className="logo-breathe relative z-10 h-44 w-44 object-contain drop-shadow-[0_0_30px_rgba(30,136,255,0.45)] sm:h-56 sm:w-56"
          draggable={false}
        />
        {/* orbiting ring */}
        <div className="absolute inset-0 -m-6 rounded-full border border-white/5" />
        <div
          className="absolute inset-0 -m-6 rounded-full border-t-2 border-[#3aa0ff]"
          style={{ animation: "spin 2.2s linear infinite" }}
        />
      </div>

      {/* Brand text */}
      <div className="mt-10 text-center">
        <div className="text-[10px] uppercase tracking-[0.6em] text-white/40">
          Playground
        </div>
        <div className="mt-3 font-serif text-2xl text-white/90 sm:text-3xl">
          Preparando tu espacio
        </div>
      </div>

      {/* Progress bar */}
      <div className="mt-10 w-[280px] max-w-[80vw] sm:w-[360px]">
        <div className="h-[2px] w-full overflow-hidden rounded-full bg-white/10">
          <div
            className="h-full bg-gradient-to-r from-[#1e88ff] to-[#7cc4ff] transition-[width] duration-100 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="mt-3 flex justify-between text-[10px] uppercase tracking-[0.3em] text-white/30">
          <span>Cargando</span>
          <span>{Math.floor(progress)}%</span>
        </div>
      </div>
    </div>
  );
}
